
import state from './moduleCalendarManagementState'
import mutations from './moduleCalendarManagementMutations'
import actions from './moduleCalendarManagementActions'
import getters from './moduleCalendarManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

